import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import "./i18n/i18n";
import { msalInitPromise } from './auth/authMsal';
import './styles/fonts.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

msalInitPromise.then(() => {
  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
});